import useNetworksControllerState from './useNetworksControllerState'

export default useNetworksControllerState
